import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { getCdnUrl } from '@/helpers';
import { useGetUpsellQuery } from '@/services/course';
import styled, { StyledProp } from '@/styled';

import Modal from './Modal';
import ImageRatio from '../ImageRatio';

const OfferCard = (props: StyledProp) => {
  const { hash } = useParams<{ hash: string }>();
  const { data, isLoading } = useGetUpsellQuery(hash, { skip: !hash });
  const [open, setOpen] = useState(false);

  const toggleModal = () => setOpen(isOpened => !isOpened);

  if (isLoading || Object.keys(data ?? {}).length === 0) {
    return null;
  }

  const currentImage = getCdnUrl(data?.showcase_image ?? '');

  return (
    <div className={props.className}>
      <Modal open={open} onCancel={toggleModal} />

      <ImageRatio aspect='1:1' src={currentImage} alt={`Imagem da oferta: ${data?.title}`} onClick={toggleModal} />
    </div>
  );
};

export default styled(OfferCard)`
  width: calc(100% - 48px);
  margin: 0 auto;

  img {
    cursor: pointer;
  }
`;
